export default "__VITE_ASSET__ddca40ab__"